/**
 * Created by markusr on 10.6.2015.
 * This component also affects the navigational functioning of the course
 * @component {"type":"ModularNavigation","version":"1.0"}
 */
define('modular-navigation',['knockout', 'helpers', 'user-answers'], function(ko, helpers, UserAnswers) {
    'use strict';

    return function(parentVM, dataContext) {

        var self		    	= this,
            tvm                 = parentVM.training,
            evm                 = parentVM.entity,
            trainingData        = dataContext.learning.training,
            component           = null,
            componentContent    = null,
            rowCount            = null,
            rowIndex,
            navHelp             = helpers.navigation,

            userAnswers = new UserAnswers();

        self.items              = ko.observableArray([]);
        self.gridItems          = ko.observableArray();

        self.exists             = ko.observable(false);
        self.inCourse           = ko.observable(false);
        self.classes            = ko.observable('');
        self.useGrid            = ko.observable(true);
        self.colCount           = ko.observable(1);
        self.rowCount           = ko.observable();
        self.showNumbers        = ko.observable(true);
        self.hideToc            = ko.observable(false);


        if (!dataContext.learning || !dataContext.learning.current) {
            return;
        }

        function itemActionExecute(item){
            var contentEntityID;

            if(!item.locked(item)) {
                switch (item.action) {
                    case "openGlossary":
                        // TODO
                        break;

                    // Go to actions
                    case "goToPageN":
                        contentEntityID = tvm.trainingMap()[item.n - 1];
                        break;

                    case "goToPageNFromEnd":
                        var trainingMap = tvm.trainingMap();
                        contentEntityID = tvm.trainingMap()[(trainingMap.length - item.n)];
                        break;

                    case "goToSectionNFromEnd":
                        contentEntityID = navHelp.getSectionNFromEndId(item.n, trainingData.contentEntities);
                        break;

                    case "goToSectionN":
                        contentEntityID = navHelp.getSectionNId(item.n, trainingData.contentEntities);
                        break;

                    case "goToFullSectionWithSameIndex":
                    default:
                        contentEntityID = navHelp.getSectionNId(item.i, trainingData.contentEntities);
                        break;
                }
                if (contentEntityID) {
                    tvm.goTo(contentEntityID);
                }
            }
        }

        function fillLastRow(){
            var lastRow = self.gridItems()[rowIndex];

            for(var i = lastRow().length; i < self.colCount(); i++) {
                var item = {kind: "FillItem"};
                self.gridItems()[rowIndex].push(item);
            }
        }

        self.pageChanged = function(){
            component = tvm.getComponentsByKind('ModularNavigation')[0];
            if(component){
                self.exists(true);
                componentContent = component.content;
                self.items([]);
                self.gridItems([]);

                if (componentContent && componentContent.items && Array.isArray(componentContent.items)) {

                    self.showNumbers(componentContent.showNumbers);
                    if (parseInt(componentContent.colCount) < 1){
                        // don't use grid, add col-count-0 class
                        self.colCount(0);
                        self.useGrid(false);

                    }else{
                        self.colCount(parseInt(componentContent.colCount));
                    }
                    self.classes("col-count-"+ self.colCount());

                    var itemCount = componentContent.items.length;
                    if(self.useGrid() == true) {
                        var rc = parseInt(componentContent.rowCount);
                        if(!isNaN(rc)){
                            rowCount = rc;
                        }else {
                            rowCount = Math.ceil(itemCount / self.colCount());
                        }
                        self.rowCount(rowCount);
                        self.classes(self.classes() +" row-count-" + rowCount);
                    }

                    var i = 1;
                    rowIndex = 0;

                    componentContent.items.forEach(function (item) {
                        var menuItem = item.content,
                            mod = i % self.colCount(),
                            contentEntityId;

                        menuItem.i = i;
                        menuItem.id = 'menu-item-' + i;
                        menuItem.kind = item.kind;
                        menuItem.unlockItems = (menuItem.unlockItems) ? menuItem.unlockItems.replace(/ /g, "").split(","): [];
                        menuItem.locked = function(item) {
                            var locked = false;
                            if (item.unlockItems.length > 0) {
                                item.unlockItems.forEach(function (itemNum) {
                                    if (self.items().length > 0) {
                                        var item = self.items()[itemNum - 1];
                                        if (!item.visited) {
                                            locked = true;
                                        }
                                    }
                                });
                            }
                            return locked;
                        };

                        switch(menuItem.action){
                            case "openGlossary":
                                // TODO
                                break;

                            case "goToPageN":
                                contentEntityId = tvm.trainingMap()[menuItem.n - 1];
                                break;

                            case "goToPageNFromEnd":
                                var trainingMap = tvm.trainingMap();
                                contentEntityId = tvm.trainingMap()[(trainingMap.length - menuItem.n)];
                                break;

                            case "goToSectionNFromEnd":
                                contentEntityId = navHelp.getSectionNFromEndId(menuItem.n, trainingData.contentEntities);
                                break;

                            case "goToSectionN":
                                contentEntityId = navHelp.getSectionNId(menuItem.n, trainingData.contentEntities);
                                break;

                            case "goToFullSectionWithSameIndex":
                            default:
                                contentEntityId = navHelp.getSectionNId(menuItem.i, trainingData.contentEntities);
                                break;
                        }

                        menuItem.visited = userAnswers.isSectionVisited(contentEntityId);

                        //menuItem.textLength = (menuItem && menuItem.text) ? menuItem.text.length : 0;
                        //menuItem.opacity = ko.observable(componentContent.itemOpacity);
                        menuItem.buttonType = ko.observable(componentContent.buttonType);
                        menuItem.classes = ko.observable("menu-item"+ (menuItem.buttonType() ? menuItem.buttonType(): "") + (menuItem.visited ? " visited": "") + (menuItem.locked(menuItem) ? " locked": "") );

                        menuItem.attr = function(str) {
                            return 'menu-item-' + str;
                        };

                        menuItem.toggleOpacity = function(data, e) {
                            e.target.style.opacity = (e.type === 'mouseover') ? 0.9 : 1;
                        };

                        menuItem.itemAction = function(data, e) {
                            itemActionExecute(menuItem, e.target);
                        };

                        if(mod == 1 || self.colCount() === 1){
                            self.gridItems.push(ko.observableArray());
                        }
                        if (self.gridItems()[rowIndex]) {
                            self.gridItems()[rowIndex].push(menuItem);
                        }
                        self.items.push(menuItem);

                        if(mod == 0 && self.items().length < componentContent.items.length){
                            rowIndex++;
                        }

                        i++;
                    });
                    if(self.useGrid()){
                        // Add objects for filling the last row with empty cells
                        fillLastRow();

                        if(rowIndex < rowCount){
                            for(; rowIndex + 1 < rowCount; ) {
                                var item = ko.observableArray();
                                self.gridItems().push(item);

                                rowIndex++;
                                fillLastRow();
                            }
                        }
                    }
                }


            } else {
                component = null;
                self.exists(false);
                self.items([]);
                self.gridItems([]);
                self.showNumbers(true);
                self.classes('');
                self.useGrid(true);
                self.colCount(1);
            }
        };

        // called once at the end of trainingVM
        function init(data) {
            evm.modularNavigation = self;

            if(data.training.contentEntities) {
                data.training.contentEntities.forEach(function (entry) {
                    // Go through 1st level pages. Look for ModularNavigation
                    if (entry.contentEntity.components != undefined) {
                        entry.contentEntity.components.forEach(function (comp) {
                            if (comp.kind == "ModularNavigation") {
                                component = comp;
                                self.inCourse(true);
                                // parentVM.layout.staticBodyClasses.push('modular-navigation');
                                evm.isModularNavigation(true);

                                if (component.content.index.length > 0) {
                                    component.content.index.forEach(function (item) {
                                        if (component.content[item]) {
                                            if (item == "returnToMainFromSections") {
                                                if (component.content[item] == true) {
                                                    // Set navigation to return to modular navigation page
                                                    // training.modularMenuPageID = entry.contentEntityId;

                                                    /* Backwards compatibility */
                                                    // These are used in pagination but could be removed and use training module's modularMenuPageID
                                                    tvm.returnFromSections = true;
                                                    tvm.returnFromSectionsId = entry.contentEntityId;
                                                    tvm.setNaviTargetId();
                                                    /* Backwards compatibility END */
                                                }
                                            }
                                            if (item == "hideToc") {
                                                if (component.content[item] == true) {
                                                    self.hideToc(true);
                                                    // parentVM.layout.staticBodyClasses.push('hide-nav-menu');
                                                }
                                            }
                                        }
                                    });
                                }
                            }
                        });
                    }
                });
            }
            // pageChanged won't otherwise be called on the 1st page
            self.pageChanged();
        }

        init(dataContext.learning);
    }
});

